'use strict';

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var constants = require('./constants-0cf35288.js');
var utils = require('./utils-0dcaf4b7.js');

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay(dirtyDate) {
  utils.requiredArgs(1, arguments);
  var date = utils.toDate(dirtyDate);
  var day = date.getDay();
  return day;
}

function getWeekStartsOnMonday(locale) {
    var dateFnsLocale = utils.getDateFnsLocale(locale);
    var weekStart = utils.startOfWeek(new Date(), { locale: dateFnsLocale });
    return getDay(weekStart) === 1; // 0 is Sunday, 1 is Monday
}

function getWeekDaysLabels(locale) {
    if (locale === void 0) { locale = constants.LOCALE_OPTIONS.EN_US; }
    var dayStart = getWeekStartsOnMonday(locale) ? 5 : 4; // 5 is Monday, 4 is Sunday
    return tslib_es6.__spread(Array(7).keys()).map(function (dayIndex) { return new Date(1970, 0, dayIndex + dayStart).toLocaleDateString(locale, { weekday: 'short' }); });
}

exports.getWeekDaysLabels = getWeekDaysLabels;
